module.exports = __webpack_public_path__ + "static/cube11-0a2868ab7aae0d0135af461dc1050ae3.svg";